import { Button, SizableText, SmartLink } from '@my/ui'
import React from 'react'

const BrandAToZTabItem = ({ letter, onPress, currentSelectedLetter }) => {
  const isActive = currentSelectedLetter === letter

  return (
    <SmartLink
      Component={Button}
      theme={isActive ? 'cyan' : 'gray'}
      h={50}
      w={50}
      mr="$2"
      href={`/brands#${letter.toLocaleUpperCase()}`}
      onPress={() => onPress(letter)}
      focusStyle={{
        outlineWidth: 0,
      }}
    >
      <SizableText fontSize={16} fow="500" color={isActive ? '$primary10' : '$overlay11'}>
        {letter.toLocaleUpperCase()}
      </SizableText>
    </SmartLink>
  )
}

export default BrandAToZTabItem
